import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteAssessmentCredentialComponent } from './delete-assessment-credential.component';

@NgModule({
  declarations: [DeleteAssessmentCredentialComponent],
  imports: [
    CommonModule,
    SkeletonLoaderModule
  ],
  exports: [DeleteAssessmentCredentialComponent],
  entryComponents: [DeleteAssessmentCredentialComponent]
})
export class DeleteAssessmentCredentialModule { }
